import { render, staticRenderFns } from "./Ancestor.vue?vue&type=template&id=d23b8db4&lang=pug"
import script from "./Ancestor.vue?vue&type=script&lang=js"
export * from "./Ancestor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports